export default __webpack_public_path__ + "static/media/empty-meal.d8a9a890.jpeg";